import { connect } from 'react-redux';

import SwitchToDesktop from '../components/SwitchToDesktop';
import footerCookies from '../footerCookies';

export default connect(
  (state) => ({
    pageReloading: state.footer.pageReloading,
    stickToDesktop: state.footer.stickToDesktop !== undefined ?
      state.footer.stickToDesktop :
      footerCookies.STICK_TO_DESKTOP.name in state.userPreferences,
  })
)(SwitchToDesktop);
